import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonSize, ButtonVariant, IconName, Popover, PopoverType, usePopoverHandlers } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { BasketButtonError } from '@as-react/common-types';
import { Box } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SizeGuideAPI from '../../api/SizeGuideAPI';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { HtmlInclude } from '../common/html-include/HtmlInclude';
export const PromoBasketPopupSizeGuide = ({ sizeGuideInformation, basketValidationState, setBasketValidationState, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const aemConfiguration = useAemConfig();
    const { defaultRequestParams, servicesEndpoint, sizeGuidePath, isSingleLanguageSite } = aemConfiguration;
    const [sizeGuideContent, setSizeGuideContent] = useState(null);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const handleSizeGuideOpen = (e) => {
        if (basketValidationState === BasketButtonError.SKU) {
            setBasketValidationState(null);
        }
        handlePopoverOpen(e);
    };
    const getContent = () => __awaiter(void 0, void 0, void 0, function* () {
        const sizeGuideRequestParams = {
            brandId: sizeGuideInformation.brandId,
            genderId: sizeGuideInformation.genderFeatureId,
            isSingleLanguageSite: isSingleLanguageSite,
            productTypeId: sizeGuideInformation.productTypeFeatureId,
            sizeGuidePath: sizeGuidePath,
        };
        const data = yield SizeGuideAPI.fetchSizeGuide(servicesEndpoint, defaultRequestParams, sizeGuideRequestParams);
        if (!data || !data.url) {
            return null;
        }
        return SizeGuideAPI.fetchSizeGuideHTML(data.url);
    });
    useEffect(() => {
        getContent().then(content => setSizeGuideContent(content));
    }, [sizeGuideInformation]);
    if (!sizeGuideContent) {
        return null;
    }
    return (_jsxs(Box, { paddingBlockEnd: { base: '2', md: '6' }, children: [_jsx(Button, { dataQA: "size_guide", iconRight: { name: IconName.CHEVRON_RIGHT }, onClick: handleSizeGuideOpen, size: ButtonSize.SMALL, text: t('product.size.guide.link'), variant: ButtonVariant.LINK }), _jsx(Popover, { nested: true, disableClickOutside: true, anchorEl: anchorEl, type: PopoverType.MODAL, onClose: handlePopoverClose, title: t('product.size.guide.link'), dataQA: "size_guide_popup", children: _jsx(HtmlInclude, { htmlFragment: sizeGuideContent }) })] }));
};
